import type { ReactElement } from 'react'

import OrderWithdrawalForm from '../../templateComponents/OrderWithdrawalForm'

export default function OrderWithdrawal(): ReactElement {
  return (
    <div className="order-withdrawal">
      <div className="section">
        <div className="wrapper">
          <div className="content">
            <OrderWithdrawalForm />
          </div>
        </div>
      </div>
    </div>
  )
}
